import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { DeliveryAcceleratorsService } from '../delivery-accelerators.service';
import { DeliveryAcceleratorsViewPart } from './accelerators/accelerators-views.part';
// import { AdmissionsTeamsViewPart } from './teams/teams-view.part';

@Component({
	selector: 'delivery-accelerators-views-part',
	standalone: true,
	imports: [
		DeliveryAcceleratorsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './accelerators-views.part.html',
})
export class DeliveryAcceleratorsViewsPart implements OnInit {

	public service = inject(DeliveryAcceleratorsService);

	ngOnInit() {
		this.service.initializeUrl();
	}


}
